import { Injectable, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
  adminPathsEqual,
  isAdminShellNavigationPath,
  normalizeAdminPath,
} from './admin-page-back.utils';

@Injectable({ providedIn: 'root' })
export class AdminNavigationHistoryService {
  private readonly router = inject(Router);

  private readonly currentUrlSignal = signal<string | null>(null);
  private readonly previousUrlSignal = signal<string | null>(null);

  readonly previousInAppUrl = this.previousUrlSignal.asReadonly();

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.recordNavigation(event.urlAfterRedirects);
      });
  }

  private recordNavigation(urlAfterRedirects: string): void {
    const next = normalizeAdminPath(urlAfterRedirects);
    if (!isAdminShellNavigationPath(next)) {
      return;
    }

    const current = this.currentUrlSignal();
    if (current && !adminPathsEqual(current, next)) {
      this.previousUrlSignal.set(current);
    }
    this.currentUrlSignal.set(next);
  }
}
